import { BaseData, BaseDataContent } from 'types/base.type'
import { HearingResponse } from 'types/hearing.type'
import { HearingFilterRequest, HearingFilterResponse } from '../types/search-hearing.type'
import client from './client'

class HearingService {
  getByFilters = async (
    filters: HearingFilterRequest,
  ): Promise<BaseDataContent<HearingFilterResponse[]>> => {
    const { dateFrom, dateTo, name, cnjNumber, responsibleFor, type, page, pageSize, sort } =
      filters

    const url = '/oitiva/status'

    const params = {
      dateFrom,
      dateTo,
      name,
      cnjNumber,
      responsibleFor,
      type,
      page,
      pageSize,
      sort,
    }

    return await client
      .get<BaseDataContent<HearingFilterResponse[]>>(url, params)
      .then((res) => res)
  }

  create = async (): Promise<BaseData<HearingResponse>> => {
    const url = `/oitiva`

    return await client.post<BaseData<HearingResponse>>(url).then((res) => res)
  }

  findById = async (hearingId?: string): Promise<BaseData<HearingResponse>> => {
    const url = `/oitiva/${hearingId}`

    return await client.get<BaseData<HearingResponse>>(url).then((res) => res)
  }

  deleteById = async (hearingId?: number): Promise<string> => {
    const url = `/oitiva/${hearingId}/excluir`

    return await client.request<string>(url, 'POST').then((res) => res.data)
  }

  reactivateById = async (hearingId?: number): Promise<BaseData<string>> => {
    const url = `/oitiva/${hearingId}/reativar`

    return await client.post<BaseData<string>>(url).then((res) => res)
  }
}

export default new HearingService()
